import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Header from "./component/Header";
import Footer from "./component/Footer";
import { useEffect, useState } from "react";
import Aos from "aos";
import Home from "./pages/Home";
import BlogPage from "./pages/BlogPage";
import WebDev from "./pages/WebDev";
import About from "./pages/About";
import AICreations from "./pages/AiCreations";
import Service from "./pages/Service";
import ContactUs from "./component/ContactUs";
import OurWork from "./pages/OurWork";
import { ToastContainer, toast } from "react-toast";
import CustomPhpDev from "./pages/CustomPhpDev";
import UIUXDev from "./pages/UIUXDev";
import MobileDev from "./pages/MobileDev";
import SEO from "./pages/SEO";
import BlogDetail from "./pages/BlogDetail";
import BestwebCompany from './pages/BestwebCompany';
import BestUIUXDesign from './pages/BestUIUXDesign';
import LeadingPhpCompany from './pages/LeadingPhpCompany';
import CustomAppServices from './pages/CustomAppServices';
import OurWorkDetail from './pages/OurWorkDetail';
import CustomAppDevelopment from './pages/CustomAppDevelopment';
import ResponsiveMobileOptimized from './pages/ResponsiveAndMobileOptimized';
import UserCentricExperience from './pages/UserCentricExperience';
import EcommerceSolutions from './pages/EcommerceSolutions';
import ContentManagementSystems from './pages/ContentManagementSystems';
import SeoOptimizedWebDevelopment from './pages/SeoOptimizedWebDevelopment';
import MobileAppDevelopment from './pages/MobileAppDevelopment';
import AppUiUxDesign from './pages/AppUiUxDesign';
import EnterpriseMobileSolutions from './pages/EnterpriseMobileSolutions';
import AppMaintenanceUpdates from './pages/AppMaintenanceUpdates';
import AppStoreOptimization from './pages/AppStoreOptimization';
import UserResearchAnalysis from './pages/UserResearchAnalysis';
import WireframingPrototyping from './pages/WireframingPrototyping';
import CustomUiDesign from './pages/CustomUiDesign';
import BrandIdentityDevelopment from './pages/BrandIdentityDevelopment';
import MobileFirstDesign from './pages/MobileFirstDesign';
import LogoDesign from './pages/LogoDesign';
import UserExperienceOptimization from './pages/UserExperienceOptimization';
import ExpertDevelopers from './pages/ExpertDevelopers';
import FlexibleModels from './pages/FlexibleModels';
import CostEffectiveSolutions from './pages/CostEffectiveSolutions';
import DirectCommunication from './pages/DirectCommunication';
import Scalability from './pages/Scalability';
import RegularUpdates from './pages/RegularUpdates';
import BugFixesPerformanceOptimization from './pages/BugFixesPerformanceOptimization';
import BackupRecovery from './pages/BackupRecovery';
import ContentUpdates from './pages/ContentUpdates';
import SecurityMonitoring from './pages/SecurityMonitoring';
import SearchEngineOptimizations from './pages/SearchEngineOptimizations';
import PayPerClickAdvertising from './pages/PayPerClickAdvertising';
import SocialMediaMarketing from './pages/SocialMediaMarketing';
import ContentMarketing from './pages/ContentMarketing';
import LogoCollateralDesign from './pages/LogoCollateralDesign';
import AppStorePlayStoreOptimization from './pages/AppStorePlayStoreOptimization';
import BrandMessagingVoice from './pages/BrandMessagingVoice';
import HowToBuildLightningFastWebsiteswithJamstack from './pages/HowToBuildLightningFastWebsiteswithJamstack';
import HowAIIsReshapingTheFutureIn from './pages/HowAIIsReshapingTheFutureIn';
import TopBestWebHostingServices from './pages/TopBestWebHostingServices';
import WebThreeMeetsAi from './pages/WebThreeMeetsAi';
import TariffsInTheItSector from './pages/TariffsInTheItSector';
import AiBeyondChatbots from './pages/AiBeyondChatbots';


function App() {
  useEffect(() => {
    Aos.init({
      duration: 1000,
    });

    const blob = document.querySelector("#blob");
    const body = document.querySelector("body");

    const handleMouseMove = (e) => {
      let half = blob.offsetWidth / 2;
      blob.style.left = `${e.clientX - half}px`;
      blob.style.top = `${e.clientY - half}px`;
    };

    body.addEventListener("mousemove", handleMouseMove);

    return () => {
      body.removeEventListener("mousemove", handleMouseMove);
    };

    toast("Thank you for contacting us, we will get in thouch soon.", {
      backgroundColor: "#323131",
      color: "#ffffff",
    });
  }, []);

  return (
    <Router>
      <div id="full_wrapper" className="home_page">
        <div id="overlay">
          <ToastContainer position="bottom-right" delay={6000} />
        </div>
        <div id="blob"></div>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/career" element={<OurWork />} />
          <Route path="/blog" element={<BlogPage />} />
          {/* <Route path="/blog/:tag" element={<BlogPage />} /> */}
          <Route path="/blog/:blogId" element={<BlogDetail />} />
          <Route path="/service" element={<Service />} />
          <Route path="/custom-php-development" element={<CustomPhpDev />} />
          <Route path="/ui-ux" element={<UIUXDev />} />
          <Route path="/mobile-dev" element={<MobileDev />} />
          <Route path="/seo" element={<SEO />} />
          <Route path="/portfolio" element={<OurWorkDetail />} />
          <Route path="/best-web-development-company" element={<BestwebCompany />} />
          <Route path="/best-UI-UX-design" element={<BestUIUXDesign />} />
          <Route path="/how-to-build-lightning-fast-websites-with-jamstack" element={<HowToBuildLightningFastWebsiteswithJamstack />} />
          <Route path="/how-ai-is-reshaping-the-future-in-2025" element={<HowAIIsReshapingTheFutureIn />} />
          <Route path="/leading-php-company" element={<LeadingPhpCompany />} />
          <Route path="/custom-mobile-app-development-services" element={<CustomAppServices />} />
          <Route path="/resource-allocation" element={<CustomPhpDev />} />
          <Route path="/maintenance" element={<WebDev />} />
          <Route path="/custom-app-development" element={<CustomAppDevelopment/>} />
          <Route path="/responsive-and-mobile-optimized" element={<ResponsiveMobileOptimized/>} />
          <Route path="/user-centric-experience" element={<UserCentricExperience/>} />
          <Route path="/e-commerce-solutions" element={<EcommerceSolutions/>} />
          <Route path="/content-management-systems" element={<ContentManagementSystems/>} />
          <Route path="/seo-optimized-web-development" element={<SeoOptimizedWebDevelopment/>} />
          <Route path="/mobile-app-development" element={<MobileAppDevelopment/>} />
          <Route path="/app-uiux-design" element={<AppUiUxDesign/>} />
          <Route path="/enterprise-mobile-solutions" element={<EnterpriseMobileSolutions/>} />
          <Route path="/app-maintenance-updates" element={<AppMaintenanceUpdates/>} />
          <Route path="/app-store-optimization" element={<AppStoreOptimization/>} />
          <Route path="/user-research-analysis" element={<UserResearchAnalysis/>} />
          <Route path="/wireframing-prototyping" element={<WireframingPrototyping/>} />
          <Route path="/custom-ui-design" element={<CustomUiDesign/>} />
          <Route path="/brand-identity-development" element={<BrandIdentityDevelopment/>} />
          <Route path="/mobile-first-design" element={<MobileFirstDesign/>} />
          <Route path="/logo-design" element={<LogoDesign/>} />
          <Route path="/user-experience-optimization" element={<UserExperienceOptimization/>} />
          <Route path="/expert-developers" element={<ExpertDevelopers/>} />
          <Route path="/flexible-models" element={<FlexibleModels/>} />
          <Route path="/cost-effective-solutions" element={<CostEffectiveSolutions/>} />
          <Route path="/direct-communication" element={<DirectCommunication/>} />
          <Route path="/scalability" element={<Scalability/>} />
          <Route path="/regular-updates" element={<RegularUpdates/>} />
          <Route path="/bugfixes-performance-optimization" element={<BugFixesPerformanceOptimization/>} />
          <Route path="/backup-recovery" element={<BackupRecovery/>} />
          <Route path="/content-updates" element={<ContentUpdates/>} />
          <Route path="/security-monitoring" element={<SecurityMonitoring/>} />
          <Route path="/search-engine-optimizations" element={<SearchEngineOptimizations/>} />
          <Route path="/pay-per-click-advertising" element={<PayPerClickAdvertising/>} />
          <Route path="/social-media-marketing" element={<SocialMediaMarketing/>} />
          <Route path="/content-marketing" element={<ContentMarketing/>} />
          <Route path="/logo-collateral-design" element={<LogoCollateralDesign/>} />
          <Route path="/brand-messaging-voice" element={<BrandMessagingVoice/>} />
          <Route path="/appstore-playstore-optimization" element={<AppStorePlayStoreOptimization/>} />
           <Route path="/blog/top-best-web-hosting-services" element={<TopBestWebHostingServices/>} />
           <Route path="/blog/web-three-meets-ai" element={<WebThreeMeetsAi/>} />
          <Route path="/blog/tariffs-in-the-it-sector-how-trade-policies-impact-technology-businesses-in-2025" element={<TariffsInTheItSector/>} />
          <Route path="/blog/ai-beyond-chatbots-how-intelligent-agents-can-negotiate-resolve-disputes-run-workflows" element={<AiBeyondChatbots/>} />
          <Route path="/ai-creations" element={<AICreations/>} />
        </Routes>
        <ContactUs />
        {/* <ToastContainer delay={8000} /> */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
